import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
const posts = [
  {
    id: 1,
    imgSrc: "/images/accor/postX.png",
    altText: "Post da Revista Ceará sobre lixo na COP 30"
  }
];

const AltoAlcanceX: React.FC = () => (
  <div
    style={{
      minHeight: '100vh',
      background: '#000',
      color: '#fff',
      fontFamily: "'Inter', Arial, Helvetica, sans-serif",
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <Header />
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        maxWidth: 700,
        margin: '0 auto',
        padding: '48px 16px 0 16px'
      }}
    >
      {/* Instagram logo */}
      <img
        src="/images/logo/logoX.jpg"
        alt="Instagram"
        style={{
          width: 48,
          height: 48,
          borderRadius: 12,
          marginBottom: 24
        }}
      />

      {/* Instagram post mockup */}
      {posts.map(post => (
        <img
          key={post.id}
          src={post.imgSrc}
          alt={post.altText}
          style={{
            width: '100%',
            maxWidth: 520,
            borderRadius: 24,
            boxShadow: '0 4px 32px rgba(0,0,0,0.4)',
            marginBottom: 32
          }}
        />
      ))}
      <br />
    </div>
    <Footer />
  </div>
);

export default AltoAlcanceX;